import Container from '../../atoms/container/searchContentContainer';
import Direction from '@shared/types/enums/direction';
import FocusUtils from '@shared/utils/focus';
import Focus from '@shared/types/enums/focus';
import List from '../../sections/list/railsList/railsList';
import Rail from '../../../../shared/classes/rail';
import VerticalAnimationContainer from '@components/atoms/container/verticalAnimationContainer';
import useTransform from '@shared/components/utils/hooks/useTransform';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useRef, useState } from 'react';

const OFFSET = 278;

function SearchContent({ rails }: { rails: Rail[] }) {
  const { focus } = useAppSelector(focusSelector);
  const currentRailRef = useRef(0);
  const [animation, setAnimation] = useState('search-rails-scroll-down');
  const [style, , , changeStyle] = useTransform(0, OFFSET, Direction.VERTICAL);

  useEffect(() => {
    if (
      FocusUtils.evaluateFocus(Focus.RAILS_LIST) ||
      focus === Focus.MODAL_INPUT ||
      focus === Focus.FLOATING_MENU
    ) {
      setAnimation('search-rails-scroll-down');
      setTimeout(() => {
        changeStyle(0);
      });
    } else {
      setAnimation('search-rails-scroll-up');
      setTimeout(() => {
        changeStyle(1);
      });
    }
  }, [focus]);

  return (
    <VerticalAnimationContainer animation={animation} style={style}>
      <Container>
        <List currentRail={currentRailRef} rails={rails} />
      </Container>
    </VerticalAnimationContainer>
  );
}

export default SearchContent;
